import React from "react";
import { Grid, Box, Typography, Paper, Tooltip } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";

function Footer() {
  const contactMethods = [
    {
      icon: <CallIcon />,
      title: "Call Us",
      href: "tel:+919986460943",
      color: "#3b82f6",
      label: "Call",
    },
    {
      icon: <WhatsAppIcon />,
      title: "Chat on WhatsApp",
      href: "https://wa.me/919986460943",
      color: "#22c55e",
      label: "WhatsApp",
    },
    {
      icon: <EmailIcon />,
      title: "Send an Email",
      href: "mailto:powerelectrocontrolind@gmail.com",
      color: "#ef4444",
      label: "Email",
    },
  ];
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        px: 2,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "radial-gradient(circle at 70% 50%, rgba(59, 130, 246, 0.1) 0%, transparent 50%)",
          pointerEvents: "none",
        },
      }}
    >
      <Grid
        container
        direction="column"
        alignItems="center"
        spacing={6}
        sx={{ maxWidth: "600px", position: "relative", zIndex: 1 }}
      >
        {/* Contact Section */}
        <Grid item sx={{ width: "100%", maxWidth: "400px" }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography
              variant="h5"
              fontWeight="700"
              sx={{
                color: "white",
                mb: 2,
                fontSize: { xs: "1.4rem", sm: "1.6rem" },
              }}
            >
              Get In Touch
            </Typography>
            <Box
              sx={{
                width: "60px",
                height: "4px",
                background: "linear-gradient(90deg, #3b82f6 0%, #06b6d4 100%)",
                borderRadius: "2px",
                margin: "0 auto",
              }}
            />
          </Box>

          {/* Contact Methods Grid */}
          <Grid container spacing={2} justifyContent="center">
            {contactMethods.map((method, index) => (
              <Grid item xs="auto" key={index}>
                <Tooltip title={method.title}>
                  <Box
                    component="a"
                    href={method.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 1,
                      textDecoration: "none",
                      transition: "all 0.3s ease",
                      "&:hover .icon-wrapper": {
                        transform: "translateY(-4px)",
                        boxShadow: `0 10px 30px ${method.color}40`,
                      },
                    }}
                  >
                    <Box
                      className="icon-wrapper"
                      sx={{
                        width: "60px",
                        height: "60px",
                        background: `${method.color}20`,
                        border: `2px solid ${method.color}40`,
                        borderRadius: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: method.color,
                        fontSize: "1.5rem",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {method.icon}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "0.875rem",
                        color: "#e0e7ff",
                        fontWeight: "500",
                        textAlign: "center",
                      }}
                    >
                      {method.label}
                    </Typography>
                  </Box>
                </Tooltip>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Divider */}
        <Grid item sx={{ width: "100%" }}>
          <Box
            sx={{
              height: "1px",
              background: "linear-gradient(90deg, transparent 0%, #475569 50%, transparent 100%)",
            }}
          />
        </Grid>

        {/* Review Section */}
        <Grid item>
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Typography
              sx={{
                fontSize: "0.875rem",
                fontWeight: "600",
                textTransform: "uppercase",
                color: "#e0e7ff",
                mb: 3,
                letterSpacing: "1px",
              }}
            >
              Share Your Experience
            </Typography>
          </Box>

          <Paper
            elevation={0}
            component="a"
            href="https://g.page/r/CV7qfiFymTnaEBM/review"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              p: 3,
              background: "rgba(255, 255, 255, 0.05)",
              border: "1px solid rgba(59, 130, 246, 0.3)",
              borderRadius: "16px",
              backdropFilter: "blur(10px)",
              textDecoration: "none",
              transition: "all 0.3s ease",
              cursor: "pointer",
              "&:hover": {
                background: "rgba(59, 130, 246, 0.1)",
                border: "1px solid rgba(59, 130, 246, 0.6)",
                transform: "translateY(-4px)",
              },
            }}
          >
            <img
              src="/review.png"
              alt="Review us on Google"
              style={{
                width: "180px",
                filter: "drop-shadow(0 4px 12px rgba(59, 130, 246, 0.3))",
                transition: "all 0.3s ease",
              }}
            />
            <Typography
              sx={{
                fontSize: "0.95rem",
                color: "#e0e7ff",
                fontWeight: "500",
              }}
            >
              Help us improve
            </Typography>
          </Paper>
        </Grid>

        {/* Footer Text */}
        <Grid item>
          <Typography
            sx={{
              fontSize: "0.875rem",
              color: "#94a3b8",
              textAlign: "center",
            }}
          >
            © 2024 Power Electro Control India Pvt. Ltd. All rights reserved.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Footer;
